import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UIKitBaseComponent } from '@macs-frontend/features';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'ui-kit-view-switch',
  templateUrl: 'view-switch.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViewSwitchComponent extends UIKitBaseComponent {
  // @ts-expect-error
  @Input() type: string;
  // @ts-expect-error
  @Input() leftViewActive: boolean;
  @Output() toggle: EventEmitter<boolean> = new EventEmitter();

  handleToggle() {
    this.toggle.emit();
  }
}
